import styled, { css } from 'styled-components'
import { Modal } from 'antd'

export const UploadFileListItem = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  transition: all ease .3s;
  padding: 3px 0;
  border-bottom: 1px solid #ebebeb;

  .digital-signature, .rename {
    color: #1890FF;
    font-size: 14px;
    opacity: 0.8;

    &:hover {
      opacity: 1;

      span {
        text-decoration-line: underline;
      }
    }
  }

  .digital-signature {
    ${props =>
      props.isNotPDF
        ? css`
            cursor: no-drop !important;
            color: #ccc !important;
          `
        : css`
            cursor: pointer;
          `} ${props =>
  props.isSigned
    ? css`
        color: #2ecc71;
        cursor: no-drop;
      `
    : css`
        cursor: pointer;
        color: #1890ff;
      `}
  }
}

.anticon-check, .anticon-delete {
  transition: all ease .3s;
  color: red;
  font-size: 14px;

  &:hover {
    cursor: pointer;
  }
}

.ant-tag {
  cursor: pointer;
  padding: 2px 13px;
}

.anticon-file-text {
  margin: 0 8px 0 5px;
  color: ${props => (!props.isSigned ? 'rgba(0, 0, 0, 0.85)' : '#1890ff')};

  + span {
    flex-grow: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-right: auto;
    padding-right: 60px;
    color: ${props => (!props.isSigned ? 'rgba(0, 0, 0, 0.85)' : '#1890ff')};
  }
}
`

export const CustomStepIcon = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: ${props =>
    props.stepNumber <= props.currentStep + 1 ? '#2C65AC' : 'none'};
  color: ${props =>
    props.stepNumber <= props.currentStep + 1 ? '#fff' : '#000'};
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  border: 1px solid #adbbd5;
`

export const StepsWrapper = styled.div`
  margin-top: 20px;
  margin-bottom: 30px;
  position: relative;
  .steps {
    width: 100% !important;
    display: ${({ count, i }) => (count > i ? '-webkit-box' : '')};

    transform: translateX(30px);
    .ant-steps-item-title,
    .ant-steps-item-description {
      color: #000000d9 !important;
    }
    .ant-steps-item-wait .ant-steps-item-icon > .ant-steps-icon {
      color: #000000d9 !important;
      font-weight: 500;
    }
    
    .ant-steps-item-content {
      width: ${({ i }) => (i == 4 ? '225px' : '220px')}; !important;
      transform: translateX(-30px);
    }
    .tag-selected {
      border-radius: 35px;
      padding: 2px 8px 2px 3px;
      display: flex;
      margin-right: 0;
      align-items: center;
    }
  }
  .ant-steps-label-vertical.ant-steps-small:not(.ant-steps-dot) .ant-steps-item-icon {
    margin-left: 70px !important;
  }
  .ant-steps-label-vertical .ant-steps-item-tail {
    margin-left: 86px;
    width: 90%;
  }
  @media screen and (min-width: 1600px) {
    .steps {
      display: ${({ i }) => (i == 5 ? 'flex' : '-webkit-box')} !important;
    }
  }
`

export const ModalCreateSignDocWrapper = styled(Modal)`
  .ant-modal-content {
    background-color: #e3edfc !important;
    border-radius: 16px !important;
  }
  .ant-modal-header {
    background-color: transparent !important;
    border-bottom: none !important;
    padding: 24px 24px 0 24px !important;
  }
  .ant-modal-title {
    font-size: 20px !important;
    font-weight: 600 !important;
    color: #333 !important;
  }
  .ant-modal-body {
    padding: 24px !important;
  }
  .ant-modal-close {
    top: 16px;
    right: 16px;
  }
  
  .inner-form-card {
    background-color: #fff;
    border-radius: 16px;
    padding: 24px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.05);
  }
  
  .ant-input {
    border-radius: 8px;
    height: 40px;
  }

  .ant-select-selector {
    border-radius: 8px !important;
    min-height: 40px !important;
    display: flex;
    align-items: center;
  }
  
  .dragger-upload-custom {
    background-color: #fafafa;
    border: 1px dashed #d9d9d9;
    border-radius: 8px;
    padding: 20px 0;
    text-align: center;
    cursor: pointer;
    transition: border-color 0.3s;
    margin-bottom: 20px;
    
    &:hover {
      border-color: #1890ff;
    }
  }
`
